"use client";

import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";

export default function PostHogPageView(): null {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      const url =
        window.location.origin + location.pathname + location.searchStr;
      posthog.capture("$pageview", {
        $current_url: url,
      });
    }
  }, [location.pathname, location.searchStr, posthog]);

  return null;
}
